import styled from 'styled-components'

export const Container = styled.div`
    padding-top: 6px;
`

export const FieldList = styled.div`
    /* padding-bottom: 4px; */
`

export const FieldItem = styled.div`
    height: 28px;
    background: #eceff4;
    border-radius: 4px;
    padding: 0 8px;
    display: flex;
    align-items: center;
    margin-bottom: 4px;
`

export const FieldItemTitle = styled.div`
    color: var(--color-gray-600);
    font-size: 12px;
    font-weight: 400;
    margin-left: 4px;
`

export const Text = styled.span<{ color?: string }>`
    color: ${props => props.color || 'var(--color-gray-600)'};
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    word-wrap: break-word;
    white-space: pre-wrap;
`
